export var WithdrawWayType;
(function (WithdrawWayType) {
    WithdrawWayType["CURRENCY_DEBIT_CARD"] = "debit_card";
    WithdrawWayType["CURRENCY_CRYPTO_ERC"] = "erc20";
    WithdrawWayType["CURRENCY_CRYPTO_TRC"] = "trc20";
    WithdrawWayType["CURRENCY_TOPAY"] = "topay";
    WithdrawWayType["CURRENCY_EBPAY"] = "ebpay";
    WithdrawWayType["CURRENCY_GOUBAO"] = "goubao";
    WithdrawWayType["CURRENCY_CGPAY"] = "cgpay";
    WithdrawWayType["CURRENCY_CGPAY_USDT"] = "cgpay_usdt";
    WithdrawWayType["CURRENCY_KOIPAY"] = "koipay";
    WithdrawWayType["CURRENCY_PAY988"] = "pay988";
    WithdrawWayType["CURRENCY_PAY808"] = "pay808";
    WithdrawWayType["CURRENCY_KDPAY"] = "kdpay";
    WithdrawWayType["CURRENCY_ALIPAY"] = "alipay";
    WithdrawWayType["AGENT_TRANSFER_WITHDRAW"] = "agent_transfer_withdraw"; // 提至經銷錢包
})(WithdrawWayType || (WithdrawWayType = {}));
//# sourceMappingURL=WithdrawWayType.js.map